var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.199997mm",
    height: "96.199997mm",
    viewBox: "0 0 96.199997 96.199997",
    id: "svg1",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.189712,
    y: 290.88297,
    width: 288.6796,
    height: 226.32671,
    id: "rect25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.28619,
    y: 132.619,
    width: 142.78329,
    height: 240.28841,
    id: "rect10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.189712,
    y: 290.88297,
    width: 670.51605,
    height: 243.0251,
    id: "rect25-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.189712,
    y: 290.88297,
    width: 670.51605,
    height: 243.0251,
    id: "rect25-9-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0.1,0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10-9",
    style: {
      display: "inline"
    },
    transform: "translate(0.09999695,-0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3e8e8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1-0",
    width: 96,
    height: 96,
    x: -5.5511151e-17,
    y: 0,
    ry: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d3dbdd",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.1309,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path11",
    cx: 44.654682,
    cy: 43.392075,
    r: 32.328999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 44.709551,12.190747 v 4.748788",
    id: "path5-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 44.709552,69.844614 v 4.748789",
    id: "path5-3-15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 75.910879,43.392074 H 71.16209",
    id: "path5-3-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 18.257011,43.392074 H 13.508223",
    id: "path5-3-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 71.730693,27.79141 -4.11257,2.374394",
    id: "path5-20-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.719,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 21.80098,56.618345 17.688408,58.99274",
    id: "path5-3-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 60.310216,70.413217 57.935821,66.300646",
    id: "path5-3-5-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 31.483281,20.483503 29.108887,16.370932",
    id: "path5-3-0-39-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 60.310215,16.370932 -2.374394,4.112571",
    id: "path5-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 31.625372,66.300647 -2.374394,4.112571",
    id: "path5-3-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 71.730692,58.992738 67.618126,56.618346",
    id: "path5-3-5-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9999",
      fillOpacity: 1,
      stroke: "#8e8e8e",
      strokeWidth: 3.71862,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 21.80098,30.165805 17.688408,27.791411",
    id: "path5-3-0-3-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#8e8e8e",
      strokeWidth: 3.49476,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 31.782561,31.01882 44.709552,43.392074",
    id: "path4-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#8e8e8e",
      strokeWidth: 3.49476,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 45.676627,43.47807 11.842631,-0.086",
    id: "path4-9-7"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8e8e8e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.42685,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3-5",
    cx: 0.87409234,
    cy: 62.277153,
    r: 3.3875301,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#8e8e8e",
      strokeWidth: 3.84648,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2-11",
    cx: 44.709553,
    cy: 43.392075,
    r: 32.274128
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect11",
    style: {
      fill: "#fc0000",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.194,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 83.385877,51.306198 c -2.773253,-2.773253 -7.238364,-2.773603 -10.011611,-3.56e-4 l -6.685798,6.685797 -6.685439,-6.685438 c -2.773252,-2.773252 -7.238714,-2.773252 -10.011962,-5e-6 l -0.353327,0.353329 c -2.773255,2.773254 -2.773255,7.238716 -2e-6,10.011968 l 6.685438,6.685439 -6.685794,6.685793 c -2.773246,2.773248 -2.772897,7.238361 3.57e-4,10.01161 l 0.353326,0.353326 c 2.773252,2.773257 7.238363,2.773608 10.011612,3.6e-4 l 6.685792,-6.685796 6.685794,6.685796 c 2.773253,2.773248 7.23836,2.772897 10.011614,-3.6e-4 l 0.353328,-0.353326 c 2.773248,-2.773249 2.773603,-7.238352 3.51e-4,-10.01161 l -6.685795,-6.685792 6.685799,-6.685798 c 2.773246,-2.773247 2.772896,-7.238358 -3.58e-4,-10.011611 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/Expired.f9174ec5959cfb4d6b5a5eba3ac9fb05.svg";
export { ForwardRef as ReactComponent };